import { useTranslation } from 'react-i18next';
import { AlertTriangle } from 'lucide-react';

/**
 * P-13 (D-109) — "X עובדים בלי עלות. הרווחיות לא מדויקת".
 *
 * Rendered inside profitability surfaces only, so it is seen only by whoever
 * may see profitability (the server returns the count with the report and
 * 403s everyone else). Nothing is rendered when every active employee has a
 * cost in effect today.
 */
export default function MissingCostWarning({ count }: { count?: number | null }) {
  const { t } = useTranslation();
  if (!count || count <= 0) return null;
  return (
    <div role="status" data-missing-cost-warning=""
      className="flex items-start gap-2 rounded-lg border border-warning-200 bg-warning-50 px-3 py-2 text-sm text-warning-900">
      <AlertTriangle size={16} className="flex-shrink-0 mt-0.5" aria-hidden="true" />
      <span>{t('employeeProfiles.missingCostWarning', { count })}</span>
    </div>
  );
}
